module.exports = __webpack_public_path__ + "static/logosplace-51cd012cd2b36f7a90d733b97fea9327.png";